<a href="/logout" class="logout">
  Log Out
  <i class="logout__icon material-icons">exit_to_app</i>
</a>
